import {
  EditorialBadgeBlock,
  EditorialCompareAtBlock,
  EditorialMetadataBlock,
  EditorialPanel,
} from "../editorial";

/**
 * Detalles · paso 1 · La portada de la ficha.
 *
 * Los tres bloques que se leen SIN bajar: la palabra sobre la foto
 * grande, el precio tachado de la ficha larga y los cuatro datos de un
 * vistazo que van bajo el botón de comprar.
 *
 * Van juntos porque se deciden juntos: son el escaparate, y se escriben
 * mirando cómo queda la parte de arriba de la página.
 */
export function CoverStep() {
  return (
    <EditorialPanel
      title="Portada de la ficha"
      description="Lo primero que se ve. Escribe lo que tengas: ninguno es obligatorio y se puede dejar para después."
    >
      {(locale) => (
        <>
          <EditorialBadgeBlock locale={locale} />
          <EditorialCompareAtBlock locale={locale} />
          <EditorialMetadataBlock locale={locale} />
        </>
      )}
    </EditorialPanel>
  );
}
